export default "__VITE_ASSET__D3LG0h12__"